/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type CancelBookingMutationVariables = Exact<{
  guid: string | number;
  cancelReason: Types.BookingCancelReason;
}>;


export type CancelBookingMutation = { cancelBooking: { isSucceeded: boolean } | null };


export const CancelBookingDocument = gql`
    mutation CancelBooking($guid: ID!, $cancelReason: BookingCancelReason!) {
  cancelBooking(guid: $guid, cancelReason: $cancelReason) {
    isSucceeded
  }
}
    `;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelBookingMutation({
 *   variables: {
 *     guid: // value for 'guid'
 *     cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useCancelBookingMutation(options: VueApolloComposable.UseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, options);
}
export type CancelBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelBookingMutation, CancelBookingMutationVariables>;